import React, {useMemo, useState} from 'react';
import {IImportConfig} from '@src/@interfaces/components/Import/IImportConfig';
import DropZone from '@src/components/_views/configurable/import-view/file-receiver/DropZone';
import useUploader from '@src/hooks/useUploader';
import {IAsyncUploaderStatusRequest} from '@src/@interfaces/services/Http/IAsyncUploaderStatusRequest';
import app from '@src/helpers/app';
import {IModelFileToImportModel} from '@src/@interfaces/models/ModelFileToImport/IModelFileToImportModel';
import List from '@src/components/_views/configurable/import-view/file-list/List';
import ErrorRepresentation from '@src/components/ErrorRepresentation/ErrorRepresentation';

export default function FileReceiver(props: {
    controllerName: string,
    config: IImportConfig,
}) {
    const {controllerName, config} = props;
    const [error, setError] = useState<Error | null>(null);
    const {push} = useUploader();

    const {onDrop} = useMemo(() => {
        const context = {
            type: 'model-import-file',
            model: controllerName,
        };

        const onDrop: React.ComponentProps<typeof DropZone>['onDrop'] = async files => {
            setError(null);

            const requestBody: IAsyncUploaderStatusRequest[] = files.map(file => ({
                name: file.name,
                size: file.size,
                type: file.type,
                lastModified: file.lastModified,
                context,
            }));

            return app('http').route(
                    'abstract-models.import.store',
                    {},
                    {
                        json: {
                            'controller-name': controllerName,
                            files: requestBody,
                        }
                    },
            ).then((models: IModelFileToImportModel[]) => {
                files.forEach(file => push(file, context));

                return models;
            }).catch(e => {
                if (e instanceof Error) {
                    setError(e);
                }

                throw e;
            });
        };

        return {context, onDrop};
    }, [controllerName, push]);

    return <>
        <div className="card">
            <div className="card-body">
                {error != null ? (
                        <ErrorRepresentation
                                error={error}
                                withoutStackTrace
                                withoutErrorName
                                size="sm"
                                outsideContainer
                                className="mb-3"
                        />
                ) : null}

                <DropZone onDrop={onDrop}/>
            </div>
        </div>

        <div className="card">
            <div className="card-body">
                <List controllerName={controllerName} config={config}/>
            </div>
        </div>
    </>;
}
